import { Datagrid, DateField, ListProps } from 'react-admin';
import { CustomList } from '../../components';

export default function VisitBlockedDaysList(props: ListProps) {
  return (
    <CustomList {...props} sort={{ field: 'date', order: 'DESC' }}>
      <Datagrid>
        <DateField 
          locales="pt-BR" 
          options={{ timeZone: 'UTC' }} 
          label="Data" 
          source="day" 
        />
      </Datagrid>
    </CustomList>
  );
}
